import { baseBackend } from "../../../../../api/base/baseUrl";

export async function getLastDriverPaymentRequest(driverId) {
  return baseBackend.get(`/api/v2/driver-payments/last/${driverId}`);
}
